import { Spinner } from 'components/design';
import OWContainer from 'styles/styled-components/ow-container';
import { WebsiteForm } from '../components/website-form';
import useController from '../controllers/add-website-controller';

export const AddWebsiteRoute = () => {
    const { formData, companies, onSubmit, onCancel, onChange, isLoading, isAddWebsiteLoading, errors } =
        useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <WebsiteForm
                    formData={formData}
                    products={undefined}
                    companies={companies}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onChange={onChange}
                    isSaveLoading={isAddWebsiteLoading}
                    errors={errors}
                />
            )}
        </OWContainer>
    );
};
